import script from "./pictures.vue?vue&type=script&lang=js"
export * from "./pictures.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/components/form/input-only/pictures.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1328232a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1328232a', __exports__)) {
    console.log('reload')
    api.reload('1328232a', __exports__)
  }
  
}


export default __exports__